// -- Lib imports --
import { createSidebar } from '@lib/plugins/sidebar';
import type { SidebarItemType } from '@lib/stores/app-sidebar-menu';
import type { AuthUser } from '@lib/types';

// -- The sidebar menu, filtered by the lib on each entry's permissions --
function buildSidebarMenu(user: AuthUser): Array<SidebarItemType> {
	return [
		{
			label: 'header_me',
			values: {
				firstname: user.firstname,
				lastname: user.lastname,
			},
		},
		{ to: '/home', icon: 'fa fa-home', label: 'home' },
		{ label: 'tools._' },
		{ to: '/tools/decommission', icon: 'fa-arrow-rotate-left', label: 'tools.decommission' },
		{ to: '/tools/site-search', icon: 'fa-magnifying-glass', label: 'tools.site_search' },
		{ to: '/tools/prepare-site', icon: 'fa-wand-magic-sparkles', label: 'tools.prepare_site' },

		{ divider: true },
		{ label: 'header_admin' },
		{ to: '/admin/users', icon: 'fa-users', label: 'users', permissions: ['users.read'] },
		{ to: '/admin/settings', icon: 'fa-cogs', label: 'settings', permissions: ['app.settings'] },
		{
			to: '/admin/maintenance',
			icon: 'fa-screwdriver-wrench',
			label: 'maintenance',
			permissions: ['app.developer'],
		},
	];
}

export default createSidebar({ menu: buildSidebarMenu });
